// Third Party Library
import { Layout, Space, Col, Card, Button } from "antd";
import { useNavigate } from "react-router-dom";

// Constants
import { ROUTE, ROOT_CONSTANT } from "../../../../constants";

// Components
import { LoginHeader, CopyRightFooter } from "../../../../components";
import SSOFPFooter from "../SSOFPFooter";

// Style
import styles from "../../../index.module.css";

const { Content } = Layout;
const { MODULE_ROUTE } = ROUTE;
const { icon_check } = ROOT_CONSTANT.IMG.ICON;

const SSOForgotPasswordChanged = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.mainWrap}>
      <Card className={styles.mainCard}>
        <Space direction="vertical" style={{ width: "100%" }} size={[0, 48]}>
          <Layout style={{ backgroundColor: "#ffffff" }}>
            <LoginHeader />
            <Content>
              <Col style={{ textAlign: "center" }} span={8} offset={8}>
                <h2 className={styles.textTitle}>Reset Password</h2>
                <img
                  src={icon_check}
                  alt=""
                  style={{ width: "50px", height: "50px", marginTop: "40px" }}
                />
                <p className={styles.textDetailsForgetPass}>
                  Your password has been reset. You can now login to your Bolt
                  Advance Portal with new password.
                </p>
              </Col>
            </Content>
            {/* <SSOFPFooter
                loading={false}
                page={MODULE_ROUTE.FORGOT_PASSWORD_NEW_PASSWORD}
                submit={() => navigate(MODULE_ROUTE.Login)}
              /> */}
            <Button
              className={styles.buttonForget}
              type="primary"
              htmlType="submit"
              onClick={() => navigate(MODULE_ROUTE.Login)}
            >
              Login
            </Button>
          </Layout>
        </Space>
      </Card>

      <CopyRightFooter />
    </div>
  );
};

export default SSOForgotPasswordChanged;
